import { useFormContext } from 'react-hook-form';
import { FormEditorForm } from '../../../shared';
import { FfcChildProps, getFieldErrors } from '../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';

const SectionFieldConfiguration = ({ fieldIndex }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper fieldConfigType="section">
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
    </FieldConfigurationWrapper>
  );
};

export default SectionFieldConfiguration;
